import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";

const DEFAULT_SITE_TITLE = "CirclePlug";

const initialState = {
  title: DEFAULT_SITE_TITLE,
};

const siteTitleSlice = createSlice({
  name: "siteTitle",
  initialState,
  reducers: {
    setSiteTitle: (state, action) => {
      state.title = action.payload || DEFAULT_SITE_TITLE;
    },
    resetSiteTitle: (state) => {
      state.title = DEFAULT_SITE_TITLE;
    },
  },
});

export const getSiteTitle = (state: RootState) =>
  state.siteTitle.title || DEFAULT_SITE_TITLE;

export const { setSiteTitle, resetSiteTitle } = siteTitleSlice.actions;
export default siteTitleSlice.reducer;
